export function ShouldApplyToSubCharts(boxList, theDoc) {
  if (boxList == null) {
    console.log("ShouldApplyToSubCharts - boxList is Null");
    return false;
  }

  for (var i in boxList) {
    var aBox = boxList[i];
    var dbObj = aBox.GetDataObj();
    if (theDoc.IsInMainSubChart(dbObj)) {
      var l = aBox.GetLayout();
      return l.GetSubChartID();
    }
  }

  return false;
}
